<template>
  <div class="step-container">
    <div class="number">
      <span>{{ index }}</span>
    </div>
    <div class="title" v-if="$slots.default">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepCommit",
  props: {
    index: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="stylus" scoped>
.step-container
  &.active
    .number
      &:before
        background #4299e1
      span
        background #4299e1
    .title
      color #4299e1
  &.on
    .number
      &:before
        background #aacff2
      span
        background #aacff2
    .title
      color #aacff2
  .number
    width 160px
    height 30px
    position relative
    &:before
      content ''
      display inline-block
      width 100%
      height 6px
      background #e6e6e6
      border-radius 5px
      position absolute
      top 50%
      transform translateY(-3px)
    span
      display inline-block
      width 24px
      height 24px
      line-height 24px
      border-radius 50%
      background #e6e6e6
      color #fff
      text-align center
      position absolute
      left 50%
      top 50%
      transform translateX(-12px) translateY(-12px)
      font-family 'Helvetica'
      font-size 16px
  .title
    text-align center
    margin-top 10px
    font-size 12px
    color #ccc
</style>
